import { styled } from '@mui/system';
import { FC } from 'react';
import { useIcon } from '../../Hooks/useIcon';

interface IconBlockProps {
  documentLink?: string;
  iconBackground: string;
  iconColor: string;
  icon: string;
}

const RootDiv = styled('div')({
  margin: '5px',
});

const IconBlockDiv = styled('div')({
  fontSize: '32px',
  padding: '10px 10px 10px',
  textAlign: 'center',
  alignContent: 'center',
  borderRadius: '50%',
});

const IconBlock: FC<IconBlockProps> = ({
  documentLink,
  iconBackground,
  iconColor,
  icon,
}) => {
  return (
    <RootDiv
      data-href={documentLink}
      style={{
        cursor: documentLink ? 'pointer' : 'initial',
      }}
    >
      <IconBlockDiv style={{ backgroundColor: iconBackground }}>
        <TitleIcon color={iconColor} iconName={icon} />
      </IconBlockDiv>
    </RootDiv>
  );
};

export default IconBlock;

interface TitleIconProps {
  color: string;
  iconName: string;
}

const TitleIcon: FC<TitleIconProps> = ({ color, iconName }) => {
  const Icon = useIcon({ color, iconName });
  return <>{Icon}</>;
};
